export type HomeBootLoaderHandle = {
  setProgress: (percent: number, statusText?: string) => void;
  finish: () => void;
  destroy: () => void;
};

export function mountHomeBootLoader(title: string): HomeBootLoaderHandle {
  const root = document.createElement("div");
  root.className = "home-boot-loader";
  root.setAttribute("role", "status");
  root.setAttribute("aria-live", "polite");
  root.setAttribute("aria-busy", "true");
  root.innerHTML = `
    <div class="home-boot-loader__panel">
      <p class="home-boot-loader__eyebrow">Mind Survival</p>
      <p class="home-boot-loader__title">${escapeHtml(title)}</p>
      <div class="home-boot-loader__track" aria-hidden="true">
        <div class="home-boot-loader__fill"></div>
      </div>
      <p class="home-boot-loader__status"></p>
    </div>
  `;

  const fill = root.querySelector<HTMLElement>(".home-boot-loader__fill");
  const status = root.querySelector<HTMLElement>(".home-boot-loader__status");
  let current = 0;
  let removed = false;

  const setProgress = (percent: number, statusText?: string) => {
    if (removed || !fill) return;
    current = Math.max(current, Math.min(100, Math.round(percent)));
    fill.style.width = `${current}%`;
    if (statusText && status) status.textContent = statusText;
  };

  const destroy = () => {
    if (removed) return;
    removed = true;
    root.remove();
  };

  const finish = () => {
    if (removed) return;
    setProgress(100, status?.textContent || undefined);
    root.classList.add("home-boot-loader--done");
    root.setAttribute("aria-busy", "false");
    window.setTimeout(() => destroy(), 360);
  };

  document.body.appendChild(root);
  setProgress(4, "เตรียมระบบ…");

  return { setProgress, finish, destroy };
}

function escapeHtml(text: string): string {
  return text
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}
